import { render, staticRenderFns } from "./iconographyInf.vue?vue&type=template&id=00f8275e"
import script from "./iconographyInf.vue?vue&type=script&lang=js"
export * from "./iconographyInf.vue?vue&type=script&lang=js"
import style0 from "./iconographyInf.vue?vue&type=style&index=0&id=00f8275e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports